import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { PendingEditManagerVM } from 'cd-eft/components/common/PendingEditManager/PendingEditManagerVM';
import './PendingEditManager.scss';
import { MeasureToolboxView } from 'cd-eft/components/common/MeasureTools/MeasureToolboxView';
import { DrawingToolboxView } from 'cd-eft/components/common/DrawingTools/view/DrawingToolboxView';

// Design
import { mdiClose, mdiPlus, mdiHammerWrench, mdiContentSave, mdiPencil, mdiTrashCanOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { ToolSlot } from '../../BreaklineTools/framework/Tool';
import { appConfig } from 'cd-eft/config/AppConfig';
import { UserLeavingWarning } from 'cd-eft/components/common/UserLeavingWarning/UserLeavingWarning';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import undoIcon from 'cd-eft/assets/images/undo-icon.svg';
import stores from '../../../../models/Stores';
const { designStore } = stores.AppStore;


interface IPendingEditManagerComponentProps {
  vm: PendingEditManagerVM;
  toolSlot?: ToolSlot;
}

function PendingEditManagerComponent(props: IPendingEditManagerComponentProps) {
  const vm = props.vm;

  const [isAutoBreaklineVisible, setIsAutoBreaklineVisible] = useState(false);

  useEffect(() => {
    if (vm.wdtGroupsLength > 0 || designStore.terraceGroupsLength > 0 || designStore.ugoGroupsLength > 0) {
      vm.openToolBar()
    }
  }, [vm.wdtGroupsLength, designStore.terraceGroupsLength, designStore.ugoGroupsLength]);

  useEffect(() => {
    vm.activeTab = (designStore.designElementTypeId !== appConfig.hardCodes.designElementTypeSuface || designStore.currentSurface.surfaceDefClassName === 'dem') ? 'Measure' : 'Breaklines';
  }, [designStore.designElementTypeId])

  return (
    <>
      {/* popups  */}
      {designStore.designElementTypeId !== appConfig.hardCodes.designElementTypeSuface &&
        vm.drawings.pendingEditCount > 0 && (
          <UserLeavingWarning
            when={vm.drawings.pendingEditCount > 0}
            section={vm.drawingsGroupLayerByDesignElementType[designStore.designElementTypeId].title}
            onOK={vm.userLeavingUncommitedEditsWarningOnOk}
            okText="Return"
            text={
              vm.drawings.pendingEditCount > 0
                ? MessageCenter.getFromCache('Common_15') +
                vm.drawingsGroupLayerByDesignElementType[designStore.designElementTypeId].title
                : ''
            }
          />
        )}

      {!!designStore.designElementTypeId && (
        <div className="design-tool-container">
          {/* Toolbar button */}
          <button
            className="esri-widget--button design-tool-btn"
            aria-label="close tool"
            onClick={() =>
              vm.toggleToolbar(designStore.designElementTypeId, designStore.currentSurface.surfaceDefClassName)
            }
          >
            <Icon path={mdiHammerWrench} title="Toolbar" size={0.8} className="esri-collapse__icon esri-icon-public" />
          </button>

          {!vm.hideToolbar && (
            <div className="design-toolbar">
              {/* Toolbar panel */}

              {/* Toolbar panel tabs */}
              <div className="design-toolbar-tab">
                <button
                  className={`esri-icon-polyline ${vm.activeTab === 'Breaklines' ? 'active' : ''} ${designStore.currentSurface.surfaceDefClassName === 'dem' ? 'tool-disabled' : ''
                    }`}
                  aria-label="breaklines tool"
                  title="Breaklines"
                  disabled={designStore.currentSurface.surfaceDefClassName === 'dem'}
                  onClick={vm.onClickBreaklinesTool}
                  hidden={designStore.designElementTypeId !== 2}
                ></button>
                <button
                  className={`esri-icon-polygon ${vm.activeTab === 'Borderpoints' ? 'active' : ''} ${designStore.currentSurface.surfaceDefClassName === 'dem' ? 'tool-disabled' : ''
                    }`}
                  aria-label="borderpoints tool"
                  title="Borderpoints"
                  disabled={designStore.currentSurface.surfaceDefClassName === 'dem'}
                  onClick={vm.onClickBorderpointsTool}
                  hidden={designStore.designElementTypeId !== 2}
                ></button>
                <button
                  className={`esri-icon-plus-circled ${vm.activeTab === 'Tinable' ? 'active' : ''} ${designStore.currentSurface.surfaceDefClassName === 'dem' ? 'tool-disabled' : ''
                    }`}
                  aria-label="tinable tool"
                  title="Tinable"
                  disabled={designStore.currentSurface.surfaceDefClassName === 'dem'}
                  onClick={vm.onClickTinableTool}
                  hidden={designStore.designElementTypeId !== 2}
                ></button>
                <button
                  className={`esri-icon-measure ${vm.activeTab === 'Measure' ? 'active' : ''}`}
                  aria-label="measure tool"
                  title="Measure"
                  onClick={vm.onClickMeasureTool}
                ></button>
                <button
                  className={`esri-icon-authorize ${vm.activeTab === 'Drawing' ? 'active' : ''}`}
                  aria-label="drawing tool"
                  title="Drawing"
                  onClick={vm.onClickDrawingTool}
                ></button>
                <button
                  className="design-toolbar-tab-close"
                  aria-label="close tool"
                  onClick={() =>
                    vm.closeToolBar(designStore.designElementTypeId, designStore.currentSurface.surfaceDefClassName)
                  }
                >
                  <Icon path={mdiClose} title="Close" size={1} />
                </button>
              </div>

              {/* Toolbar panel body */}
              <div className="design-toolbar-body p-3">
                {vm.activeTab === 'Drawing' ? (
                  <div>
                    <h5>Drawing</h5>
                    <DrawingToolboxView drawingTools={vm.drawingTools} />
                  </div>
                ) : null}
                {vm.activeTab === 'Breaklines' && designStore.designElementTypeId === 2 ? (
                  <div>
                    {/* {vm.surfaceDef !== undefined && (
                    <BreaklineToolboxView mapView={vm.mapView} surfaceDef={vm.surfaceDef} toolSlot={props.toolSlot} />
                  )} */}
                    {/* {vm.surfaceDef !== undefined ? ( */}
                    {true ? (
                      <div className="panel-breakline">
                        <div className="panel-breakline-buttons">
                          <div className="row">
                            <div className="col">
                              <div><h5>Breaklines</h5></div>
                              <button
                                className={`esri-icon-plus`}
                                aria-label="icon plus"
                                title="Add Breakline"
                                onClick={(e) => {
                                  vm.addBreaklineTool?.toggleActivated();
                                }}
                              ></button>
                              <button
                                className={`esri-icon-refresh`}
                                aria-label="icon refresh"
                                title="Auto Breakline"
                                onClick={() => setIsAutoBreaklineVisible((prev) => !prev)}
                              ></button>
                              <button
                                className={`esri-icon-trash`}
                                aria-label="icon trash"
                                title="Delete Breakline"
                                onClick={(e) => {
                                  vm.deleteBreaklineTool?.toggleActivated();
                                }}
                              ></button>
                            </div>
                            <div className="col">
                              <div><h5>Vertex</h5></div>
                              <button
                                className={`esri-icon-plus`}
                                aria-label="icon plus"
                                title="Add Vertex"
                                onClick={(e) => {
                                  vm.addPointBreaklineTool?.toggleActivated();
                                }}
                              ></button>
                              <button
                                className="esri-icon-pan"
                                aria-label="icon pan"
                                title="Move Vertex"
                                onClick={(e) => {
                                  vm.moveBreaklineTool?.toggleActivated();
                                }}
                              ></button>
                              <button
                                className={`esri-icon-trash`}
                                aria-label="icon trash"
                                title="Delete Vertex"
                                onClick={(e) => {
                                  vm.deletePointBreaklineTool?.toggleActivated();
                                }}
                              ></button>
                              <button
                                className="esri-icon-forward"
                                aria-label="icon forward"
                                title="Extend Vertex"
                                onClick={(e) => {
                                  vm.extendBreaklineTool?.toggleActivated();
                                }}
                              ></button>
                            </div>
                          </div>
                        </div>
                        {isAutoBreaklineVisible && (
                          <div id="autoBreaklinePanel">
                            <select
                              aria-label="Description"
                              className="th-with-select usa-select"
                              name={'Description'}
                              value={vm.selctedPointDescription}
                              onChange={(e) => vm.selectDescription(e.target.value)}
                            >
                              <option value="All">{'Description'}</option>
                              {vm.uniqueDescriptions.length > 0 &&
                                vm.uniqueDescriptions.map((value, index) => (
                                  <option key={`Description-${index}`} value={value}>
                                    {value}
                                  </option>
                                ))}
                            </select>
                            <div className="row">
                              <div className="col-sm-6 text-right mt-2">
                                <input
                                  className="usa-checkbox__input"
                                  data-behavior="select-table-row"
                                  id="breakLineClosed"
                                  type="checkbox"
                                  name="breakLineClosed"
                                  value="breakLineClosed"
                                  checked={vm.isClosed}
                                  onChange={(e) => vm.toggleBreaklineClosed(e)}
                                />
                                <label className="usa-checkbox__label align-items-center" htmlFor="breakLineClosed">
                                  Closed
                                </label>
                              </div>
                              <div className="col-sm-6 mt-2">
                                <button
                                  className="usa-button"
                                  onClick={vm.onClickGenerate}
                                >
                                  Generate
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>LOADING...</div>
                    )}
                  </div>

                ) : null}
                {vm.activeTab === 'Borderpoints' && designStore.designElementTypeId === 2 ? (
                  <div>
                    <h5>Border Points</h5>
                    {/*  {vm.surfaceDef !== undefined ? ( */}
                    {true ? (
                      <div>
                        <button
                          className="usa-button usa-button--outline rounded-btn"
                          onClick={(e) => {
                            vm.addBorderTool?.toggleActivated();
                          }}
                        >
                          <Icon path={mdiPlus} title="Add" size={1} />
                          Add
                        </button>
                        <button
                          className="usa-button usa-button--outline rounded-btn"
                          onClick={(e) => {
                            vm.deleteBorderTool?.toggleActivated();
                          }}
                        >
                          <Icon path={mdiClose} title="Remove" size={1} />
                          Remove
                        </button>
                      </div>
                    ) : (
                      <div>LOADING...</div>
                    )}
                  </div>
                ) : null}
                {vm.activeTab === 'Tinable' && designStore.designElementTypeId === 2 ? (
                  <div>
                    <h5>Tinable Points</h5>
                    {true ? (
                      <div>
                        <button
                          className="usa-button usa-button--outline rounded-btn"
                          onClick={(e) => {
                            vm.editTinableTool?.toggleActivated();
                          }}
                        >
                          <Icon path={mdiPencil} title="Add" size={1} />
                          Edit
                        </button>
                      </div>
                    ) : (
                      <div>LOADING...</div>
                    )}
                  </div>
                ) : null}
                {vm.activeTab === 'Measure' ? (
                  <div>
                    <h5>Measure</h5>
                    {vm.inputManager !== undefined && (
                      <MeasureToolboxView
                        inputManager={vm.inputManager}
                        measureResults={vm.measureResults}
                        onChangeMeasureTool={vm.onChangeMeasureTool}
                        selectedMeasurementUnits={{
                          distance: vm.measureDistanceUnits,
                          area: vm.measureAreaUnits,
                          perimeter: vm.measurePerimeterUnits,
                        }}
                      ></MeasureToolboxView>
                    )}
                    {/* To show 'Distance Unit' dropdown list */}
                    {vm.measureToolType === 'measure-distance' ? (
                      <div className="select-dropdown">
                        <select
                          className="usa-select"
                          id="measure_distance_units"
                          aria-label="measure_distance_units"
                          name="measure_distance_units"
                          value={vm.measureDistanceUnits}
                          onChange={vm.onChangeDistanceUnits}
                        >
                          {/* <option value="feet">Distance Unit</option> */}
                          <option value="feet">Feet</option>
                          <option value="meters">Meters</option>
                          <option value="miles">Miles</option>
                          <option value="kilometers">Kilometers</option>
                        </select>
                      </div>
                    ) : null}
                    {/* To show 'Area/Perimeter Unit' dropdown list */}
                    {vm.measureToolType === 'measure-area' ? (
                      <div className="select-dropdown">
                        <select
                          className="usa-select"
                          id="measure_area_units"
                          aria-label="measure_area_units"
                          name="measure_area_units"
                          value={vm.measureAreaUnits + '/' + vm.measurePerimeterUnits}
                          onChange={vm.onChangeAreaPerimeterUnits}
                        >
                          {/* <option value="acres/feet">Area/Perimeter Unit</option> */}
                          <option value="square-kilometers/kilometer">Sq. Kilometers / Kilometer</option>
                          <option value="acres/feet">Acres / Feet</option>
                          <option value="hectares/meters">Hectares / Meters</option>
                          <option value="square-miles/miles">Sq. Miles / Miles</option>
                        </select>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
              {/* Toolbar footer */}
              <div className="design-toolbar-footer p-3">
                {/*  <h5>Pending edits count: {vm.uncommittedEdits} </h5> */}
                <h5>
                  Pending edits count:{' '}
                  {designStore.designElementTypeId === appConfig.hardCodes.designElementTypeSuface
                    ? vm.uncommittedEdits
                    : designStore.designElementTypeId === appConfig.hardCodes.designElementTypeWaterway
                      ? vm.wdtGroupsLength + vm.drawings.pendingEditCount
                      : designStore.designElementTypeId === appConfig.hardCodes.designElementTypeTerrace
                        ? designStore.terraceGroupsLength + vm.drawings.pendingEditCount
                        : designStore.designElementTypeId === appConfig.hardCodes.designElementTypeUGO
                          ? designStore.ugoGroupsLength + vm.drawings.pendingEditCount
                          : vm.drawings
                            ? vm.drawings.pendingEditCount
                            : 0}
                </h5>
                <div className="design-toolbar-footer-save">
                  <button
                    aria-label="Save Pending edits"
                    title="Save"
                    onClick={
                      designStore.designElementTypeId === appConfig.hardCodes.designElementTypeSuface
                        ? vm.onSavePendingEdits
                        : vm.onSaveStructurePendingEdits
                    }
                  >
                    <Icon path={mdiContentSave} title="Save" size={1} className="design-toolbar-footer-save-icon" />
                    Save Changes
                  </button>
                  {(designStore.designElementTypeId === appConfig.hardCodes.designElementTypeWaterway ||
                    designStore.designElementTypeId === appConfig.hardCodes.designElementTypeTerrace ||
                    designStore.designElementTypeId === appConfig.hardCodes.designElementTypeUGO ||
                    designStore.designElementTypeId === appConfig.hardCodes.designElementTypeSuface) && (
                      <button
                        aria-label="Undo last change"
                        title="Undo"
                        style={{ paddingLeft: '5px' }}
                        onClick={vm.onUndoLastEdit}
                        disabled={
                          vm.disableUndo ||
                          (vm.wdtGroupsLength === 0 &&
                            designStore.terraceGroupsLength === 0 &&
                            designStore.ugoGroupsLength === 0 &&
                            designStore.breakLineGroupsLength === 0)
                        }
                      >
                        <img className="design-toolbar-footer-save-icon" src={undoIcon} alt={'Undo last change'} />
                        Undo Change
                      </button>
                    )}
                  {(designStore.designElementTypeId === appConfig.hardCodes.designElementTypeWaterway ||
                    designStore.designElementTypeId === appConfig.hardCodes.designElementTypeTerrace ||
                    designStore.designElementTypeId === appConfig.hardCodes.designElementTypeUGO ||
                    designStore.designElementTypeId === appConfig.hardCodes.designElementTypeSuface) && (
                      <button
                        aria-label="Clear all edits"
                        title="Clear"
                        style={{ paddingTop: '5px' }}
                        onClick={vm.onClearAllEdits}
                        disabled={
                          vm.wdtGroupsLength === 0 &&
                          designStore.terraceGroupsLength === 0 &&
                          designStore.ugoGroupsLength === 0 &&
                          designStore.breakLineGroupsLength === 0
                        }
                      >
                        <Icon
                          path={mdiTrashCanOutline}
                          title="Clear"
                          size={1}
                          className={
                            vm.wdtGroupsLength === 0 &&
                              designStore.terraceGroupsLength === 0 &&
                              designStore.ugoGroupsLength === 0 &&
                              designStore.breakLineGroupsLength === 0
                              ? 'design-toolbar-footer-save-icon-disabled'
                              : 'design-toolbar-footer-save-icon'
                          }
                        />
                        Clear Pending Changes
                      </button>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export const PendingEditManager = observer(PendingEditManagerComponent);
